import React from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";
import { Chip } from "@mui/material";
import { getChipColor } from "../../../../constants/value";

const TmobilejChangeNumberList = ({
  data,
  loading,
  meta,
  client,
  handleColumnClick,
  disableRowClick,
}) => {
  const nav = useNavigate();

  const handleRowClick = (e) => {
    nav(`/tmobilej/change_number/${e.row.id}`);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "old_msisdn",
      headerName: "MSISDN",
      minWidth: 100,
      flex: 2,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Old MSISDN"}
            handleClick={() => handleColumnClick("old_msisdn")}
          />
        ) : (
          "Old MSISDN"
        ),
    },
    {
      field: "new_msisdn",
      headerName: "MSISDN",
      minWidth: 100,
      flex: 2,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"New MSISDN"}
            handleClick={() => handleColumnClick("new_msisdn")}
          />
        ) : (
          "New MSISDN"
        ),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 2,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
      sortable: false,
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) =>
        params.row.created_at &&
        `${format(new Date(params.row.created_at), "MMMM d, y hh:mm a")}`,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) =>
        params.row.last_updated &&
        `${format(new Date(params.row.last_updated), "MMMM d, y hh:mm a")}`,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      data={data}
      columns={columns}
      loading={loading}
      metaData={meta}
      client={client}
      handleRowClick={disableRowClick ? null : handleRowClick}
    />
  );
};

export default TmobilejChangeNumberList;
